module.exports = __webpack_public_path__ + "img/1525173179.4beac999.jpg";